import { UserLanguageType } from "@Components/Modules/Helpers";

import { CashbackLandingPageResources } from "./LandingPage/CashbackLandingPage.Resources";
import { CashbackLandingPageResourcesEn } from "./LandingPage/CashbackLandingPage.Resources.En";

export interface ICashbackCategoryData {
    name: string;
    code: string;
}

const cashbackCategoryData = (language: UserLanguageType, withALL: boolean) => {
    const resources =
        language === UserLanguageType.English
            ? CashbackLandingPageResourcesEn.categoryList
            : CashbackLandingPageResources.categoryList;

    return [
        withALL
            ? {
                  code: "ALL",
                  name: resources.nameAll,
              }
            : {
                  code: "POPULAR",
                  name: resources.namePopular,
              },
        {
            code: "MARPLACE",
            name: resources.nameMarketplace,
        },
        {
            code: "ELAGD",
            name: resources.nameTechnology,
        },
        {
            code: "MODDAM",
            name: resources.nameWomanFashion,
        },
        {
            code: "MODMEN",
            name: resources.nameManFashion,
        },
        {
            code: "DZIECI",
            name: resources.nameBaby,
        },
        {
            code: "SPORT",
            name: resources.nameSportingGoods,
        },
        {
            code: "DOM",
            name: resources.nameHome,
        },
        {
            code: "ZWI",
            name: resources.namePets,
        },
        {
            code: "ARTSPOZ",
            name: resources.nameGrocery,
        },
        {
            code: "ZDROURO",
            name: resources.nameHealthBeauty,
        },
        {
            code: "GASTR",
            name: resources.nameRestaurants,
        },
        {
            code: "TUR",
            name: resources.nameTravel,
        },
        {
            code: "USL",
            name: resources.nameServices,
        },
        {
            code: "MOT",
            name: resources.nameAutomotive,
        },
        {
            code: "UBEZP",
            name: resources.nameInsurance,
        },
        {
            code: "ROZNAU",
            name: resources.nameEntertainment,
        },
    ] as ICashbackCategoryData[];
};

export default cashbackCategoryData;
